import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@akostm/orbit-ui';
import { MessageStateType } from '../../../interfaces';
import { faCheck, faCheckDouble, faHourglass } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/angular-fontawesome/types';

@Component({
  selector: 'shared-message-state-indicator',
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  templateUrl: './message-state-indicator.component.html',
  styleUrl: './message-state-indicator.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageStateIndicatorComponent {
  state = input<MessageStateType>();

  getStateIcon(): IconProp {
    switch (this.state()) {
      case MessageStateType.Sending: {
        return faHourglass;
      }
      case MessageStateType.Sent: {
        return faCheck;
      }
      case MessageStateType.Read: {
        return faCheckDouble;
      }
      default: {
        return faHourglass;
      }
    }
  }
}
